import React, {useEffect} from 'react';
import DoctorsList from "./DoctorsList";
import IsError from "../common/IsError";
import {useAppDispatch, useTypedSelector} from "../../store";
import CalendarAppointment from './CalendarAppointment';
import {useLazyGetAppointmentTimesAddressQuery} from "../../store/rtk-api/appointment_times/appointment_times";
import {IAppDoctorTimesResult} from "../../store/rtk-api/appointment_times/types";
import {setDoctorCount} from "../../store/calendar/calendar.slice";
import {CircularProgress} from "@mui/material";

interface DoctorProps {
    portion: Date[]
}

const Doctors: React.FC<DoctorProps> = ({portion}) => {
    const dispatch = useAppDispatch()
    const {...filterData} = useTypedSelector(state => state.doctor)
    const {addressId} = useTypedSelector(state => state.header)
    //debugger
    let body = {
        id: addressId, page: filterData.page, query: filterData.query
    }
    const [getDoctors, {data: doctors, isError, isLoading}] = useLazyGetAppointmentTimesAddressQuery()
    useEffect(() => {
        if (doctors) {
            dispatch(setDoctorCount(doctors.count))
        }
    }, [doctors?.count])
    useEffect(() => {
        if (addressId){
            getDoctors({...filterData, id: addressId})
        }

    }, [filterData.query, filterData.is_active, filterData.page, addressId])
    return (
        <>
            <IsError isError={isError}/>
            {isLoading && <CircularProgress/>}

            {doctors && doctors?.results.map((doctor, ind) => {
                return <Children ind={ind} doctor={doctor} key={doctor.id} portion={portion}/>
            })}
            {/*{isOpen && <DoctorsWindow*/}
            {/*    isWindowOpen={isOpen} closeWindow={closeWindow}*/}
            {/*    isLoading={deleteLoading}*/}
            {/*    isError={deletingProductError}*/}
            {/*    isSuccess={isSuccess}*/}
            {/*    handlePerform={handlePerform}*/}
            {/*    mainTexts={["Анара С. Б."]}*/}
            {/*    btnText={"Подтвердить"}*/}
            {/*    contentItems={weekDays}*/}
            {/*/>}*/}
            {doctors?.results.length === 0 && <div style={{padding: "10px"}}>Данных пока нет...</div>}
        </>

    )
}

type Props = {
    doctor: IAppDoctorTimesResult,
    // handleWindowOpen(): void,
    ind: number,
    portion: Date[],
}


const Children: React.FC<Props> = ({doctor, ind, portion}) => {
    return (
        <div style={{display: "flex"}}>
            <div style={{width: "20%", flexFlow: "column", flexGrow: 1}}
            >
                <DoctorsList doctor={doctor}/>
            </div>
            <div style={{width: "80%", flexFlow: "column", flexGrow: 1}}>
                <CalendarAppointment ind={ind} doctor={doctor} portion={portion}/>
            </div>
        </div>

    )
}

export default Doctors;
